import { useTranslation } from 'react-i18next';
import { useSEO, generateWebPageSchema } from '../../utils/seo';
import Navbar from '../../components/feature/Navbar';
import ContactFooter from '../home/components/ContactFooter';

const TermsPage = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://evesmart.qa';

  const title = t('terms.title');
  const description = 'شروط وأحكام استخدام موقع إيف سمارت للخدمات الزراعية في قطر. Terms and conditions for using EVE Smart Agricultural Services website in Qatar.';
  const keywords = 'شروط الاستخدام, الأحكام, إيف سمارت, terms of service, conditions, EVE Smart Qatar';

  const schema = generateWebPageSchema(siteUrl, '/terms', title, description);

  useSEO({
    title,
    description,
    keywords,
    canonical: `${siteUrl}/terms`,
    schema
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <main className="pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <h1 className="font-tajawal text-4xl md:text-5xl font-bold text-gray-900 mb-4 text-center">
            {t('terms.title')}
          </h1>
          
          <p className="font-tajawal text-gray-600 text-center mb-12">
            {t('terms.lastUpdated')}: {new Date().toLocaleDateString(isRTL ? 'ar-QA' : 'en-US', { 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </p>

          <div className={`space-y-8 ${isRTL ? 'text-right' : 'text-left'}`}>
            <section>
              <p className="font-tajawal text-lg text-gray-700 leading-relaxed">
                {t('terms.intro')}
              </p>
            </section>

            <section>
              <h2 className="font-tajawal text-2xl font-bold text-gray-900 mb-4">
                {t('terms.acceptance.title')}
              </h2>
              <p className="font-tajawal text-gray-700 leading-relaxed">
                {t('terms.acceptance.content')}
              </p>
            </section>

            <section>
              <h2 className="font-tajawal text-2xl font-bold text-gray-900 mb-4">
                {t('terms.services.title')}
              </h2>
              <p className="font-tajawal text-gray-700 leading-relaxed">
                {t('terms.services.content')}
              </p>
            </section>

            <section>
              <h2 className="font-tajawal text-2xl font-bold text-gray-900 mb-4">
                {t('terms.userResponsibilities.title')}
              </h2>
              <p className="font-tajawal text-gray-700 leading-relaxed">
                {t('terms.userResponsibilities.content')}
              </p>
            </section>

            <section>
              <h2 className="font-tajawal text-2xl font-bold text-gray-900 mb-4">
                {t('terms.intellectualProperty.title')}
              </h2>
              <p className="font-tajawal text-gray-700 leading-relaxed">
                {t('terms.intellectualProperty.content')}
              </p>
            </section>

            <section>
              <h2 className="font-tajawal text-2xl font-bold text-gray-900 mb-4">
                {t('terms.liability.title')}
              </h2>
              <p className="font-tajawal text-gray-700 leading-relaxed">
                {t('terms.liability.content')}
              </p>
            </section>

            <section>
              <h2 className="font-tajawal text-2xl font-bold text-gray-900 mb-4">
                {t('terms.modifications.title')}
              </h2>
              <p className="font-tajawal text-gray-700 leading-relaxed">
                {t('terms.modifications.content')}
              </p>
            </section>

            <section>
              <h2 className="font-tajawal text-2xl font-bold text-gray-900 mb-4">
                {t('terms.governingLaw.title')}
              </h2>
              <p className="font-tajawal text-gray-700 leading-relaxed">
                {t('terms.governingLaw.content')}
              </p>
            </section>

            <div className="bg-white rounded-2xl shadow-sm p-8 mt-8">
              <h2 className="font-almarai text-2xl mb-4">{t('terms.contact.title')}</h2>
              <p className="font-tajawal text-gray-700 leading-relaxed mb-4">
                {t('terms.contact.content')}
              </p>
              <p className="font-tajawal text-gray-700">
                <strong>{isRTL ? 'البريد الإلكتروني' : 'Email'}:</strong>{' '}
                <a href="mailto:evevsmart@gmail.com" className="text-primary hover:underline">
                  evevsmart@gmail.com
                </a>
              </p>
              <p className="font-tajawal text-gray-700">
                <strong>{isRTL ? 'الهاتف' : 'Phone'}:</strong>{' '}
                <a href="tel:+97474010700" className="text-primary hover:underline" dir="ltr">
                  +974 7401 0700
                </a>
              </p>
            </div>
          </div>
        </div>
      </main>

      <ContactFooter />
    </div>
  );
};

export default TermsPage;
